import React, { useEffect, useState, useRef } from 'react'
import {
  Button,
  Accordion,
  AccordionItem,
  OverflowMenu,
  OverflowMenuItem,
  Dropdown
} from 'carbon-components-react'
import {
  Close,
  Minimize,
  Maximize,
  SendFilled,
  ChevronLeft,
  ChevronRight
} from '@carbon/icons-react'
import { MultipleChoiceAI } from '../AIChatComponents/MultipleChoiceAI'

const AiAssistanceBot = (props) => {
  const {
    chatBotSettings,
    aiChatResponse,
    isKnovoApiCall,
    onAiDialogClose,
    onClarificationClick
  } = props

  const [isMinimized, setIsMinimized] = useState(false)
  const [chatBotSettingData, setChatBotSettingData] = useState({
    topic: '',
    keyword: '',
    mode: '',
    initialContent: '',
    promptContent: '',
    commonQuestionList: []
  })
  const [isSampleQuestions, setIsSampleQuestions] = useState(true)
  const [userChatData, setUserChatData] = useState([])
  const [selectedQuestionData, setSelectedQuestionData] = useState({})
  const [clarificationResponse, setClarificationResponse] = useState({})

  useEffect(() => {
    if (chatBotSettings && chatBotSettings !== '') {
      let chatBotData = JSON.parse(chatBotSettings)
      let chatBotDataCopy = { ...chatBotSettingData }
      chatBotDataCopy.topic = chatBotData.topic
      chatBotDataCopy.keyword = chatBotData.keyword
      chatBotDataCopy.mode = chatBotData.mode
      chatBotDataCopy.initialContent = chatBotData.initialContent
      chatBotDataCopy.promptContent = chatBotData.promptContent
      chatBotDataCopy.commonQuestionList = chatBotData.commonQuestionList
      setChatBotSettingData(chatBotDataCopy)
    }
  }, [chatBotSettings])

  useEffect(() => {
    setClarificationResponse(aiChatResponse)
  }, [aiChatResponse])

  useEffect(() => {
    if (clarificationResponse.question) {
      let userChatDataCopy = [...userChatData]
      userChatDataCopy.push(clarificationResponse)
      setUserChatData(userChatDataCopy)
    }
  }, [clarificationResponse])

  function renderInitialChatBox() {
    return (
      <div className='chat-box-section'>
        <div
          className={
            isMinimized
              ? 'chat-content-sect chat-content-sect-minm'
              : 'chat-content-sect'
          }
        >
          <div className='chat-box-cont'>
            <p className='chat-box-content'>
              {chatBotSettingData.initialContent}
            </p>
          </div>
        </div>
      </div>
    )
  }

  function renderQuestionBox() {
    return (
      <div className='question-section'>
        <div className='question-header'>
          <p className='question-header-label'>Sample Questions</p>
        </div>
        <div className='question-body'>
          {chatBotSettingData.commonQuestionList.length > 0 &&
            chatBotSettingData.commonQuestionList.map((item, index) => {
              return (
                <div
                  className='question-item'
                  onClick={() => {
                    let selectedQuestion = {
                      question: item.question,
                      answer: item.answer
                    }
                    let userChatDataCopy = [...userChatData]
                    userChatDataCopy.push(selectedQuestion)
                    setUserChatData(userChatDataCopy)
                    setSelectedQuestionData(item)
                  }}
                >
                  <p className='question-label'>{item.question}</p>
                </div>
              )
            })}
        </div>
      </div>
    )
  }

  const sampleText =
    "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy."

  function renderClarificationBox() {
    const items = [
      {
        id: 'lang-spanish',
        text: 'Spanish'
      },
      {
        id: 'lang-arabic',
        text: 'Arabic'
      }
    ]
    return (
      <div className='question-section'>
        <div className='question-header'>
          <div className='question-header-icon-cont'>
            <Button
              className='question-header-icon'
              hasIconOnly
              iconDescription='Back'
              renderIcon={ChevronLeft}
              tooltipAlignment='center'
              tooltipPosition='bottom'
              onClick={() => {
                setIsSampleQuestions(true)
              }}
            />
          </div>
          <p className='question-header-label'>Clarifications</p>
        </div>
        <div className='question-body'>
          <Accordion>
            <div className='clarification-accor-item'>
              <AccordionItem
                title='Give me an analogy'
                className='accord-item-style'
                onHeadingClick={({ isOpen }) => {
                  if (isOpen) {
                    let jsonData = {
                      topic: chatBotSettingData.topic,
                      keyword: chatBotSettingData.keyword,
                      content: selectedQuestionData.answer
                    }
                    onClarificationClick('analogy', jsonData)
                  }
                }}
              >
                <p
                  className={
                    isKnovoApiCall
                      ? 'accord-label-item-inactive'
                      : 'accord-label-item'
                  }
                >
                  {isKnovoApiCall
                    ? sampleText
                    : clarificationResponse &&
                      clarificationResponse.analogy &&
                      clarificationResponse.analogy}
                </p>
              </AccordionItem>
            </div>

            <AccordionItem
              title='Translate this for me'
              className='accord-item-style'
            >
              <Dropdown
                id='translate'
                className='ai-trans-cont'
                label='Select language'
                items={items}
                itemToString={(item) => (item ? item.text : '')}
                onChange={(item) => {
                  let jsonData = {
                    topic: item.selectedItem.text,
                    content: selectedQuestionData.answer
                  }
                  onClarificationClick('translated-content', jsonData)
                }}
              />
              <p
                className={
                  isKnovoApiCall
                    ? 'accord-label-item-inactive'
                    : 'accord-label-item'
                }
              >
                {isKnovoApiCall
                  ? sampleText
                  : clarificationResponse &&
                    clarificationResponse.translated_content &&
                    clarificationResponse.translated_content}
              </p>
            </AccordionItem>
            <AccordionItem
              title='Simplify'
              className='accord-item-style'
              onHeadingClick={({ isOpen }) => {
                if (isOpen) {
                  let jsonData = {
                    topic: chatBotSettingData.topic,
                    keyword: chatBotSettingData.keyword,
                    content: selectedQuestionData.answer
                  }
                  onClarificationClick('simplified-content', jsonData)
                }
              }}
            >
              <p
                className={
                  isKnovoApiCall
                    ? 'accord-label-item-inactive'
                    : 'accord-label-item'
                }
              >
                {isKnovoApiCall
                  ? sampleText
                  : clarificationResponse &&
                    clarificationResponse.simplified_content &&
                    clarificationResponse.simplified_content}
              </p>
            </AccordionItem>
            <AccordionItem
              title='More Details'
              className='accord-item-style'
              onHeadingClick={({ isOpen }) => {
                if (isOpen) {
                  let jsonData = {
                    topic: chatBotSettingData.topic,
                    keyword: chatBotSettingData.keyword,
                    content: selectedQuestionData.answer
                  }
                  onClarificationClick('more-details', jsonData)
                }
              }}
            >
              <p
                className={
                  isKnovoApiCall
                    ? 'accord-label-item-inactive'
                    : 'accord-label-item'
                }
              >
                {isKnovoApiCall
                  ? sampleText
                  : clarificationResponse &&
                    clarificationResponse.more_details &&
                    clarificationResponse.more_details}
              </p>
            </AccordionItem>
            <div
              className='challange-container'
              onClick={() => {
                let jsonData = {
                  topic: chatBotSettingData.topic,
                  keyword: chatBotSettingData.keyword,
                  question_type: 'multiple choice',
                  num_of_options: 4,
                  content: selectedQuestionData.answer
                }
                onClarificationClick('challenge', jsonData)
              }}
            >
              Challenge me
            </div>
          </Accordion>
        </div>
      </div>
    )
  }

  useEffect(() => {
    var objDiv = document.getElementById('chatDiv')
    objDiv.scrollTop = objDiv.scrollHeight
  }, [userChatData])

  return (
    <div
      className={
        isMinimized ? 'ai-chat-model ai-chat-model-minm' : 'ai-chat-model'
      }
    >
      <div
        className={
          isMinimized
            ? 'ai-chat-container ai-chat-container-minm'
            : 'ai-chat-container'
        }
      >
        <div className='chat-header-section'>
          <p className='chat-header-label'>AI Assistance</p>
          <div className='chat-header-icons-sect'>
            {isMinimized ? (
              <Button
                className='chat-header-icons'
                hasIconOnly
                iconDescription='Maximize'
                renderIcon={Maximize}
                tooltipAlignment='center'
                tooltipPosition='top'
                onClick={() => {
                  setIsMinimized(false)
                }}
              />
            ) : (
              <Button
                className='chat-header-icons'
                hasIconOnly
                iconDescription='Minimize'
                renderIcon={Minimize}
                tooltipAlignment='center'
                tooltipPosition='top'
                onClick={() => {
                  setIsMinimized(true)
                }}
              />
            )}
            <Button
              className='chat-header-icons'
              hasIconOnly
              iconDescription='Close'
              renderIcon={Close}
              tooltipAlignment='center'
              tooltipPosition='top'
              onClick={() => {
                onAiDialogClose(true)
              }}
            />
          </div>
        </div>
        <div className='chat-body-section'>
          <div
            className={
              isMinimized
                ? 'chat-response-section chat-response-section-minm'
                : 'chat-response-section chat-response-section-minm'
            }
          >
            <div id='chatDiv' className='chat-area'>
              {renderInitialChatBox()}
              {userChatData.length > 0 &&
                userChatData.map((userChat, chatIndex) => {
                  if (userChat.options) {
                    return (
                      <MultipleChoiceAI
                        answer={userChat.answer}
                        options={userChat.options}
                        question={userChat.question}
                      ></MultipleChoiceAI>
                    )
                  } else {
                    return (
                      <div className='chat-box-section-cont'>
                        <div className='chat-box-section chat-quest'>
                          <div className='chat-content-sect chat-fit-content'>
                            <div className='chat-box-cont'>
                              <p className='chat-box-content'>
                                {userChat.question}
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className='chat-box-section'>
                          <div className='chat-content-sect chat-fit-content'>
                            <div className='chat-box-cont'>
                              <p className='chat-box-content'>
                                {userChat.answer}
                              </p>
                            </div>
                            {/* <OverflowMenu>
                            <OverflowMenuItem itemText='Give me an analogy' />
                            <OverflowMenuItem itemText='Translate this for me' />
                            <OverflowMenuItem itemText='Simplify' />
                            <OverflowMenuItem itemText='More Details' />
                            <OverflowMenuItem itemText='Challenge me' />
                          </OverflowMenu> */}
                          </div>
                        </div>
                        <div
                          className='clarification-btn-cont'
                          onClick={() => {
                            setIsSampleQuestions(false)
                          }}
                        >
                          <ChevronRight className='clarf-btn-icon' />
                          <p className='clarf-btn-label'>View Clarifications</p>
                        </div>
                      </div>
                    )
                  }
                })}
            </div>
            <div className='chat-input-text-area'>
              <input
                className='chat-input-component'
                placeholder='Type your question here'
              ></input>
              <Button
                className='chat-send-icon'
                hasIconOnly
                iconDescription='Send'
                renderIcon={SendFilled}
                tooltipAlignment='center'
                tooltipPosition='top'
                disabled
                onClick={() => {
                  setIsMinimized(true)
                }}
              />
            </div>
          </div>
          {!isMinimized && (
            <div className='chat-question-section'>
              {/* {renderQuestionBox()} */}
              {isSampleQuestions
                ? renderQuestionBox()
                : renderClarificationBox()}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export { AiAssistanceBot }
